import React, { useState } from "react";

import { get } from "lodash";
import { Button } from "../Field";
import { getIcon } from "../../helpers/icons";
import { dateTime } from "../../helpers/date";
import Link from "../Link";
import Spacer from "../Spacer";
import PlanList from "./PlanList";
import AsyncForm from "../AsyncForm";
import Title from "../../components/Title";
import AsyncGet from "../../components/AsyncGet";
import PaymentForm from "../../pages/Widgets/Register/Step/PaymentForm";

import style from "./style.module.css";

export default function ChangePlan(props) {
    const {
        closeDialog = "",
        userProfile = {}
    } = props;

    const [step, setStep] = useState(null);
    const [changePlanId, setChangePlanId] = useState();
    const [upgradeType, setUpgradeType] = useState("Your Plan is Upgraded");
    const [message, setMessage] = useState("");
    const [planType, setPlanType] = useState();
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [paymentIntentDetails, setPaymentIntentDetails] = useState({});

    return (
        <div className={`${style.feedback} ${style.changePlan} ${style.popupArea}`}>
            <div className={style.popupWrap}>
                <div className={style.sectionHeader}>
                    {
                        step === null && (
                            <>
                                <Link
                                    className={`${style.dialogClose}`}
                                    onClick={closeDialog}
                                >
                                    <i className={getIcon("Arrow-left")}></i>
                                </Link>
                                <Title className="fontTeko" transform="uppercase" tag="h2">available Membership plans</Title>
                            </>
                        )
                    }
                    {
                        step === "step2" && (
                            <>
                                <Link
                                    className={`${style.dialogClose}`}
                                    onClick={closeDialog}
                                >
                                    <i className={getIcon("Arrow-left")}></i>
                                </Link>
                                <Title className="fontTeko" transform="uppercase" tag="h2">ENTER PAYMENT DETAILS</Title>
                            </>
                        )
                    }
                </div>
                {
                    step === null && (
                        <div className={style.sectionBody}>
                            <AsyncForm
                                id="ChangePlan"
                                url={`/membership/change-plan/${changePlanId}`}
                                permission="Change Plan"
                                showToastOnSuccess={false}
                                paramsData={{
                                    plan_type: planType
                                }}
                                onSave={({ data }) => {
                                    if(data.intent){
                                        setTotal(data.price);
                                        setPaymentIntentDetails(data.intent);
                                        setStep('step2');
                                    }
                                    else if(data){
                                        setStep('step3');
                                        setUpgradeType(get(data, 'log.price.new') > get(data, 'log.price.current') ? 'Your Plan is Upgraded' : 'Your Plan is downgraded');
                                        let upgradeMessage = `We have processed your payment.Your membership renewal date is ${dateTime(get(data, 'renewel_date'), "MMM DD, Y")}`;
                                        let downGradeMessage = `Thank you for updating your account. Your membership will remain unchanged until your next renewal date of: ${dateTime(get(data, 'renewel_date'), "MMM DD, Y")}`;
                                        setMessage(get(data, 'log.price.new') > get(data, 'log.price.current') ? upgradeMessage : downGradeMessage)
                                    }
                                }}
                                render={({ fetching, handleSubmit, onSubmit }) => {
                                    return (
                                        <>
                                        <PlanList
                                            setChangePlanId={setChangePlanId}
                                            setPlanType={setPlanType}
                                            loading={loading}
                                            userProfile={userProfile}
                                        />
                                        {
                                            changePlanId !== undefined && (
                                                <AsyncGet
                                                    url={`membership/check-price/${changePlanId}`}
                                                    permissionText={"Check Price"}
                                                    loadOnMount={changePlanId}
                                                    method="post"
                                                    paramsData={{
                                                        id: changePlanId
                                                    }}
                                                    render={({ data, fetching, status }) => {
                                                        setLoading(fetching)
                                                        if(get(data, "price") !== undefined && status === 200){
                                                            return (
                                                                <Title 
                                                                    tag="p"
                                                                >
                                                                    {get(data, "price") !== undefined ? `Additional Fee: £${get(data, "price")}` : ""}
                                                                </Title>
                                                            )
                                                        }
                                                    }}
                                                />
                                            )
                                        }
                                        <div className={style.buttonRow}>
                                            <Button
                                                disabled={!changePlanId}
                                                color="buttonPrimary"
                                                onClick={handleSubmit(onSubmit)}
                                                fetching={fetching}
                                                label="NEXT"
                                            />
                                            <Button
                                                onClick={closeDialog}
                                                color="buttonPrimaryWithOutBg"
                                                label="CANCEL"
                                            />
                                        </div>
                                        </>
                                    )
                                }}
                            />
                        </div>
                    )
                }
                {
                    step === "step2" && (
                        <div className={`${style.sectionBody} ${style.paymentPopup}`}>
                            <PaymentForm
                                planId={changePlanId}
                                userId={userProfile.id}
                                planType={planType}
                                paymentIntentDetails={paymentIntentDetails}
                                color="buttonPrimary"
                                from="changeplan"
                                total={total}
                            />
                        </div>
                    )
                }
                {
                    step === "step3" && (
                        <div className={style.sectionBody}>
                            <Title 
                                className="fontTeko" 
                                tag="h4"
                            >
                                {upgradeType}
                            </Title>
                            <Spacer />
                            <Title tag="p">{message}</Title>
                            <div className={style.buttonRow}>
                                <Button 
                                    onClick={() => { window.location.reload() }} 
                                    label="Close" 
                                    color="buttonPrimary"
                                />
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    )
}